export const fileToDataUrl = (file) =>
  new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () => resolve(reader.result);
    reader.onerror = () => reject(new Error("Failed to read file"));
    reader.readAsDataURL(file);
  });

export const formatFileSize = (bytes, useDecimal = false) => {
  if (!bytes || bytes === 0) return "0 Bytes";

  const divisor = useDecimal ? 1000 : 1024;
  const units = ["Bytes", "KB", "MB", "GB", "TB"];
  let unitIndex = 0;
  let sizeValue = bytes;

  while (sizeValue >= divisor && unitIndex < units.length - 1) {
    sizeValue /= divisor;
    unitIndex += 1;
  }

  // Round to 1 decimal place for values >= 1, otherwise show 2 decimal places
  const decimals = sizeValue >= 1 ? 1 : 2;
  return `${sizeValue.toFixed(decimals)} ${units[unitIndex]}`;
};

export const validateFile = (
  file,
  allowedTypes = [],
  maxFileSize = Infinity,
  allowedTypesError = "Invalid file type",
  maxFileSizeError = "File size too large",
) => {
  const typeError =
    allowedTypes.length > 0 && !allowedTypes.includes(file.type)
      ? allowedTypesError
      : null;
  const sizeError = file.size > maxFileSize ? maxFileSizeError : null;
  return typeError ?? sizeError ?? null;
};
